"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObfuscationSettingsOptions = exports.ObfuscationSettingsOptionEnum = exports.SlotConstraintOptions = exports.SlotConstraintOptionEnum = exports.SlotTypeResolutionStrategyArray = exports.SlotTypeResolutionStrategyEnum = void 0;
var SlotTypeResolutionStrategyEnum;
(function (SlotTypeResolutionStrategyEnum) {
    SlotTypeResolutionStrategyEnum["TOP_RESOLUTION"] = "TOP_RESOLUTION";
    SlotTypeResolutionStrategyEnum["ORIGINAL_VALUE"] = "ORIGINAL_VALUE";
})(SlotTypeResolutionStrategyEnum || (exports.SlotTypeResolutionStrategyEnum = SlotTypeResolutionStrategyEnum = {}));
exports.SlotTypeResolutionStrategyArray = [
    SlotTypeResolutionStrategyEnum.TOP_RESOLUTION,
    SlotTypeResolutionStrategyEnum.ORIGINAL_VALUE
];
var SlotConstraintOptionEnum;
(function (SlotConstraintOptionEnum) {
    SlotConstraintOptionEnum["Required"] = "Required";
    SlotConstraintOptionEnum["Optional"] = "Optional";
})(SlotConstraintOptionEnum || (exports.SlotConstraintOptionEnum = SlotConstraintOptionEnum = {}));
exports.SlotConstraintOptions = [
    SlotConstraintOptionEnum.Required,
    SlotConstraintOptionEnum.Optional
];
var ObfuscationSettingsOptionEnum;
(function (ObfuscationSettingsOptionEnum) {
    ObfuscationSettingsOptionEnum["DefaultObfuscation"] = "DefaultObfuscation";
    ObfuscationSettingsOptionEnum["None"] = "None";
})(ObfuscationSettingsOptionEnum || (exports.ObfuscationSettingsOptionEnum = ObfuscationSettingsOptionEnum = {}));
exports.ObfuscationSettingsOptions = [
    ObfuscationSettingsOptionEnum.DefaultObfuscation,
    ObfuscationSettingsOptionEnum.None
];
